module.exports = __webpack_public_path__ + "static/media/text.a586eb04.png";